function parseDisclosures(disclosures): Disclosure[] {
  return Object.keys(disclosures).map(key => {
    const { details, category, requireAcknowledgement } = disclosures[key]

    const content = details.content.map(info => ({
      text: info.html,
      filters: info.filter || info.filters
    }))

    return {
      id: +key,
      category,
      requireAcknowledgement,
      confirmationMessage: details.confirmationMessage,
      content,
      condition: details.condition
    }
  })
}

export default parseDisclosures
